import type { Pair } from '../messages';

/**
 * Landing copy and the public 404. Russian values are copied from the source markup untouched:
 * this is the marketing voice the project already has, English is written next to it, not over it.
 */
export const landing = {
  'landing.eyebrow': ['Ваше место в интернете', 'Your place on the internet'],
  'landing.heroTitle1': ['Для всего,', 'For everything'],
  'landing.heroTitle2': ['что хочется', 'worth'],
  'landing.heroTitle3': ['сохранить.', 'keeping.'],
  'landing.heroLede': [
    'Фильмы, книги, статьи — рядом. Сохраняйте находки и собирайте из них свои подборки.',
    'Films, books, articles — all in one place. Save what you find and turn it into your own collections.',
  ],
  'landing.openLibrary': ['Открыть библиотеку', 'Open your library'],
  'landing.createLibrary': ['Создать библиотеку', 'Create a library'],
  'landing.heroNote': ['Только ваш выбор. Никаких алгоритмов.', 'Only your choices. No algorithms.'],
  'landing.previewAlt': ['Пример вашей будущей коллекции', 'What your collection could look like'],
  'landing.demoCollection': ['Подборка', 'Collection'],
  'landing.demoCollectionTitle1': ['На долгие', 'For a long'],
  'landing.demoCollectionTitle2': ['выходные', 'weekend'],
  'landing.demoCollectionSub': ['Книги, кино и время для себя', 'Books, film and time for yourself'],
  'landing.demoBookKind': ['Книга / Фрэнк Герберт', 'Book / Frank Herbert'],
  'landing.demoBookTitle': ['Дюна', 'Dune'],
  'landing.demoBookSub': ['Миры, в которые возвращаются', 'Worlds you keep returning to'],
  'landing.demoFilmKind': ['Фильм / 2014', 'Film / 2014'],
  'landing.demoFilmTitle1': ['Интер-', 'Inter-'],
  'landing.demoFilmTitle2': ['стеллар', 'stellar'],
  'landing.demoFilmAuthor': ['Кристофер Нолан', 'Christopher Nolan'],
  'landing.demoCaption': ['К примеру, ваша следующая подборка', 'For example, your next collection'],
  'landing.howCaps': ['От случайной находки — к личной коллекции', 'From a stray link — to a personal collection'],
  'landing.howTitle': ['Хорошие вещи заслуживают своего места.', 'Good things deserve a place of their own.'],
  'landing.foundTitle': ['Нашли. Сохранили.', 'Found it. Saved it.'],
  'landing.foundBody': [
    'Вставьте ссылку — название и обложка появятся сами. При желании добавьте что-то от себя.',
    'Paste a link — the title and cover arrive on their own. Add a word from you if you feel like it.',
  ],
  'landing.storyTitle': ['Соберите свою историю', 'Assemble your own story'],
  'landing.storyBody': [
    'Фильмы на выходные или книги, с которых всё началось. Задайте порядок и добавьте свои комментарии.',
    'Films for the weekend or the books it all started with. Set the order and add your own notes.',
  ],
  'landing.privateTitle': ['Личное остаётся личным', 'What is personal stays personal'],
  'landing.privateBody': [
    'Ваша библиотека видна только вам. Делитесь отдельными подборками — когда захотите.',
    'Your library is visible to you alone. Share a single collection whenever you want.',
  ],
  'landing.footer': ['Интернет большой. Это — ваше.', 'The internet is huge. This part is yours.'],
  'notfound.title': ['Такой страницы нет', 'No such page'],
  'notfound.body': [
    'Возможно, подборку сделали приватной, профиль переименовали — или в адресе просто опечатка.',
    'Maybe a collection was made private, a profile renamed — or the address simply has a typo.',
  ],
  'notfound.feed': ['В ленту', 'To the feed'],
  'notfound.home': ['На главную', 'Home'],
  'notfound.library': ['К библиотеке', 'To the library'],
  'notfound.account': ['Создать аккаунт', 'Create an account'],
} satisfies Record<string, Pair>;
